module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div>\n    <div class="content-container">\n        <section class="row button-label-row properties">\n            <div class="col-md-5">\n                Text\n            </div>\n            <div class="col-md-7">\n                <input type="text" class="button-label-input full-width" placeholder="Label&#8230;">\n            </div>\n        </section>\n        <div class="character-properties"></div>\n    </div>\n</div>\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/editor/ui/experience/widgets/button/LabelPropertiesView.tpl
// module id = 1781
// module chunks = 0